import { render, staticRenderFns } from "./ClientPostLogoutRedirectUriSave.vue?vue&type=template&id=4a75a8d4&scoped=true&"
import script from "./ClientPostLogoutRedirectUriSave.vue?vue&type=script&lang=ts&"
export * from "./ClientPostLogoutRedirectUriSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a75a8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a75a8d4')) {
      api.createRecord('4a75a8d4', component.options)
    } else {
      api.reload('4a75a8d4', component.options)
    }
    module.hot.accept("./ClientPostLogoutRedirectUriSave.vue?vue&type=template&id=4a75a8d4&scoped=true&", function () {
      api.rerender('4a75a8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientPostLogoutRedirectUri/ClientPostLogoutRedirectUriSave.vue"
export default component.exports